module.exports = __webpack_public_path__ + "static/media/C1_GLOSS.35e7281c.png";